// XPEN-3802: a submitted expense report keeps a line for each of its live expenses.
// The API lets the report's owner, someone who files for the owner (an assistant, a
// universal proxy) or the accounting team's correction action remove a report line (403
// expense_report_line_removal_forbidden for anyone else) and says so on the invoice it
// returns (can_remove_report_lines). It refuses an
// approval request on a report with no line (409 expense_report_empty) or whose expense has
// no line (409 expense_report_line_missing, with the expenses named).
import AccessControl from './access_control';

const isOwner = (invoice, data) => {
  const owner = invoice?.user || {};
  if (owner.id_user && data?.id_user) return String(owner.id_user) === String(data.id_user);
  return Boolean(owner.username) && owner.username === data?.username;
};

// The API's answer when the invoice carries it; otherwise the part of the rule the
// session can check, without the assistant links it does not hold.
export const canRemoveReportLines = (invoice, data) => {
  if (invoice?.type !== 'XPENSE') return true;
  if (typeof invoice.can_remove_report_lines === 'boolean') return invoice.can_remove_report_lines;
  return isOwner(invoice, data) || AccessControl.userCanCorrectValidatedExpenses(data);
};

// The translated refusal, naming the expenses when some lost their line; null for any other error.
export const reportRefusalMessage = (error, data) => {
  const body = error?.response?.data;
  if (body?.error === 'expense_report_empty') return data.t.read('expense_report_lines.empty');
  if (body?.error !== 'expense_report_line_missing') return null;
  const names = (Array.isArray(body.expenses) ? body.expenses : [])
    .map((expense) => expense?.name || expense?.checksum)
    .filter(Boolean)
    .join(', ');
  // A replacer function keeps a "$" in an expense name as written.
  return data.t.read('expense_report_lines.line_missing').replace('{names}', () => names);
};
